import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Application } from "../../types";

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: "#ffffff",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  gafeteContainer: {
    width: "48%",
    height: "48%",
    margin: "1%",
    border: "3px solid #c96f51",
    borderRadius: 8,
    padding: 15,
    backgroundColor: "#f8fafc",
  },
  header: {
    marginBottom: 10,
    textAlign: "center",
  },
  headerImages: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    marginTop: 15,
  },
  titulo: {
    fontSize: 12,
    color: "#003b5c",
    marginTop: 3,
  },
  subtitulo: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#003b5c",
    marginTop: 10,
  },
  fotoContainer: {
    alignItems: "center",
    marginVertical: 12,
  },
  fotoPlaceholder: {
    width: 120,
    height: 120,
    backgroundColor: "#cbd5e1",
    borderRadius: 60,
    border: "3px solid #e6a619",
    justifyContent: "center",
    alignItems: "center",
  },
  fotoTexto: {
    fontSize: 10,
    color: "#64748b",
    width: 110,
    height: 110,
    objectFit: "contain",
    borderRadius: 60,
  },
  infoContainer: {
    marginTop: 8,
  },
  label: {
    fontSize: 8,
    color: "#64748b",
    marginBottom: 2,
  },
  dato: {
    fontSize: 11,
    color: "#003b5c",
    fontWeight: "bold",
    marginBottom: 8,
    paddingBottom: 5,
    borderBottom: "1px solid #e2e8f0",
  },
  footer: {
    position: "absolute",
    bottom: 10,
    left: 15,
    right: 15,
    textAlign: "center",
    fontSize: 7,
    color: "#94a3b8",
  },
  standsContainer: {
    marginTop: 5,
  },
  standTexto: {
    fontSize: 9,
    color: "#1e293b",
  },
});

// Componente de Gafete Individual
interface GafeteProps {
  name: string;
  career: string;
  project: string;
  logo: string;
}

const Gafete: React.FC<GafeteProps> = ({ name, career, project, logo }) => (
  <View style={styles.gafeteContainer}>
    <View
      style={[
        styles.gafeteContainer,
        {
          position: "absolute",
          zIndex: 0,
          opacity: 1,
          width: "100%",
          height: "100%",
          border: "0px",
          padding: -15,
          top: -3,
          left: -3,
        },
      ]}
    >
      <Image
        style={{
          width: "100%",
          height: "100%",
        }}
        src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/background-pattern.png"
      />
    </View>
    <View style={styles.header}>
      <View style={styles.headerImages}>
        <View
          style={{ width: "33.333%", height: 40, alignItems: "flex-start" }}
        >
          <Image
            style={{
              width: 70,
              height: 40,
              objectFit: "contain",
            }}
            src="/logo-uat.png"
          />
        </View>
        <View style={{ width: "33.333%", height: 40, alignItems: "center" }}>
          <Image
            style={{
              width: 40,
              height: 40,
              objectFit: "contain",
            }}
            src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/feria.png"
          />
        </View>
        <View style={{ width: "33.333%", height: 40, alignItems: "flex-end" }}>
          <Image
            style={{
              width: 70,
              height: 40,
              objectFit: "contain",
            }}
            src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/uamvh-logotipo.png"
          />
        </View>
      </View>

      <Text style={[styles.titulo, { marginTop: 10 }]}>
        Feria de Emprendedores 2025
      </Text>
      <Text style={styles.titulo}>UAT - UAMVH</Text>
      <Text style={styles.subtitulo}>EXPOSITOR</Text>
    </View>

    <View style={styles.fotoContainer}>
      <View style={styles.fotoPlaceholder}>
        <Image style={styles.fotoTexto} src={logo} />
      </View>
    </View>

    <View style={styles.infoContainer}>
      <Text style={styles.label}>NOMBRE:</Text>
      <Text style={styles.dato}>{name}</Text>

      {/* <Text style={styles.label}>CARRERA:</Text>
      <Text style={styles.dato}>{carrera}</Text>

      <Text style={styles.label}>PROYECTO:</Text>
      <Text style={styles.dato}>{proyecto}</Text> */}
    </View>

    {/* <Text style={styles.footer}>
      Universidad • Departamento de Emprendimiento
    </Text> */}
  </View>
);

// Documento PDF
export const ExhibitorBadge: React.FC<{ applications: Application[] }> = ({
  applications,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {applications.map((exp, index) => (
        <Gafete
          key={index}
          name={exp.fullName}
          career={exp.studentFaculty}
          project={exp.businessName}
          logo={exp.businessLogo}
        />
      ))}
    </Page>
  </Document>
);
